import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { LessonForCopy, ShortDataLesson, StudentClass } from '@df/interfaces';
import { TeacherService } from '@app/teacher/services/teacher.service';
import { DatePipe } from '@angular/common';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { of, throwError } from 'rxjs';

@Component({
    selector: 'app-copy-form',
    templateUrl: './copy-form.component.html',
    styleUrls: ['./copy-form.component.scss']
})
export class CopyFormComponent implements OnInit {
    classTitle: string;
    classID: number;
    lesson: ShortDataLesson;
    teacherClasses: StudentClass[];

    lessonForCopyForm: FormGroup;
    lessonNumber: number;
    lessonDate: Date;
    availableLessonNumbers = [];

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private teacherService: TeacherService,
        private snackBar: MatSnackBar,
        private datePipe: DatePipe,
        @Inject(MAT_DIALOG_DATA) protected data: any,
        private dialogRef: MatDialogRef<CopyFormComponent>
    ) {}

    ngOnInit(): void {
        this.lesson = this.data.lesson;
        this.classID = this.data.classID;
        this.classTitle = this.data.classTitle;
        this.teacherClasses = this.data.teacherClasses;

        this.lessonNumber = this.lesson.lesson_number;
        this.lessonDate = this.lesson.date;

        this.initForm();
        this.updateAvailableLessonNumbers();
    }

    closeCopyModal(data: any = null) {
        this.dialogRef.close(data);
    }

    private initForm(): void {
        const formattedDate = this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm');
        this.lessonForCopyForm = new FormGroup({
            studentClass: new FormControl(this.classID, Validators.required),
            lessonNumber: new FormControl(null, Validators.required),
            lessonDate: new FormControl(formattedDate, Validators.required),
            lessonTitle: new FormControl(this.lesson.title, Validators.required),
            lessonRemarks: new FormControl(this.lesson.remarks ? this.lesson.remarks : 'Копия занятия', Validators.required)
        });
    }

    onClassChanged(): void {
        this.classID = this.lessonForCopyForm.get('studentClass').value;
        this.updateAvailableLessonNumbers();
    }

    updateAvailableLessonNumbers(): void {
        this.teacherService
            .getAvailableLessonNumbers(this.classID)
            .pipe(
                map((next: any) => {
                    return next.available_numbers;
                })
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe((lessonNumbers: number[]) => {
                this.availableLessonNumbers = lessonNumbers;
                this.lessonForCopyForm.get('lessonNumber').patchValue(this.availableLessonNumbers[0]);
            });
    }

    onSubmit(): void {
        const data: LessonForCopy = {
            date: new Date(this.lessonForCopyForm.value.lessonDate),
            lesson_number: this.lessonForCopyForm.value.lessonNumber,
            lesson_title: this.lessonForCopyForm.value.lessonTitle,
            lesson_remarks: this.lessonForCopyForm.value.lessonRemarks,
            student_class: this.lessonForCopyForm.value.studentClass,
            source_lesson: this.lesson.id
        };

        this.teacherService
            .copyTask(data)
            .pipe(
                takeUntil(this.destroy$),
                mergeMap(next => {
                    if (!next.response) {
                        return throwError(null);
                    }
                    return of(next);
                }),
                catchError(err => {
                    this.snackBar.open('Ошибка при копировании урока', 'Ok', {
                        duration: 2000
                    });
                    return throwError(err);
                })
            )
            .subscribe(({ response }) => {
                this.closeCopyModal(response.lesson);
            });
    }
}
